<template>
  <div class="item_extend">
    <RowCard
      :theme="theme"
      style="position: relative; padding: 24px 33px 24px 16px; gap: 0"
      :style="item.status == 'Draft' ? { color: '#F15A29' } : { color: '#000' }"
    >
      <div :style="{ width: headers[0].width }" class="flex-center gap-4">
        <v-btn v-if="item.status === 'Draft'" small icon @click="onDelete">
          <Iconify
            style="color: #b1b1b1"
            icon="basil:trash-alt-solid"
            size="15px"
          ></Iconify>
        </v-btn>
        <v-btn v-if="item.status === 'Approved'" small icon @click="onPreview">
          <Iconify icon="carbon:view-filled" size="15px"></Iconify>
        </v-btn>
      </div>

      <div :style="{ width: headers[1].width, textAlign: headers[1].align }">
        {{ index + 1 }}
      </div>

      <div
        :style="{ width: headers[2].width, textAlign: headers[2].align }"
        class="text-decoration-underline"
      >
        #{{ item?.fiscal_year }}
      </div>

      <div :style="{ width: headers[3].width, textAlign: headers[3].align }">
        <div class="txt-short">{{ item?.project_name }}</div>
        <div class="txt-short mt-3 font-w-400 font-ch" style="font-weight: 400">
          รอบที่ {{ item.plan_times }} :
          {{ toDateTimeFormat(item.start_date) }} -
          {{ toDateTimeFormat(item.end_date) }}
        </div>
      </div>

      <div
        :style="{
          width: headers[4].width,
          textAlign: headers[4].align,
          color: checkStatus(item?.status).color,
        }"
      >
        {{ item?.status }}
      </div>

      <div :style="{ width: headers[5].width, textAlign: headers[5].align }">
        <v-btn
          v-if="item.status === 'Draft'"
          depressed
          rounded
          class="btn_gradient"
          @click="extendRequest"
        >
          <v-img
            width="20"
            aspect-ratio="1"
            :src="require('../assets/images/extension-time/judge.png')"
          ></v-img>
          <span>ยื่นขยายเวลา</span>
        </v-btn>
      </div>

      <v-btn
        absolute
        top
        right
        icon
        :class="{ rotate180: isExpanded }"
        @click="seeDetail"
      >
        <Iconify
          icon="material-symbols:keyboard-arrow-down"
          color="#D3D3D3"
        ></Iconify>
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content d-flex flex-column gap-12">
        <v-layout class="font-12 font-w-700" style="color: #b1b1b1">
          <v-flex xs1></v-flex>
          <v-flex xs8>แผนงาน</v-flex>
          <v-flex xs3 class="text-center">สถานะ</v-flex>
        </v-layout>
        <v-divider />
        <v-layout
          align-center
          class="font-12 font-w-500"
          v-for="(plan, i) in item.plans"
          :key="i"
        >
          <v-flex xs1>
            <v-btn icon v-if="plan.status == 'Submitted'" @click="onEdit(plan)">
              <Iconify
                icon="solar:pen-2-bold"
                color="#F15A29"
                size="20px"
              ></Iconify>
            </v-btn>
            <v-btn icon v-if="plan.status == 'Approved'" @click="onView(plan)">
              <Iconify
                icon="ic:baseline-remove-red-eye"
                color="#3F3F3F"
                size="20px"
              ></Iconify>
            </v-btn>
          </v-flex>
          <v-flex
            xs8
            :style="
              plan.status == 'Draft' ? { color: '#b1b1b1' } : { color: '#000' }
            "
            class="font-w-500"
          >
            {{ plan.plan_name_th }}
          </v-flex>
          <v-flex
            :style="
              plan.status == 'Draft' ? { color: '#b1b1b1' } : { color: '#000' }
            "
            xs3
            class="text-center font-w-500"
            >{{ plan.status == "Draft" ? "-" : plan.status }}</v-flex
          >
        </v-layout>
      </div>
    </div>

    <v-dialog v-model="dialog" width="500">
      <v-card class="py-8 px-16">
        <div class="d-flex justify-center mt-6">
          <Iconify
            icon="ic:round-access-time-filled"
            color="#FBB040"
            size="100px"
          ></Iconify>
        </div>
        <div class="text-center font-24 font-w-700 mt-5">ยื่นขอขยายเวลา</div>
        <div class="text-center font-12 mt-3" style="color: #464647">
          เมื่อกดยื่นขอขยายเวลาแล้ว ไม่สามารถเเก้ไขข้อมูลได้
        </div>

        <v-layout class="mt-12">
          <v-flex xs6 class="pr-3">
            <v-btn
              @click="dialog = false"
              depressed
              block
              color="#D9D9D9"
              rounded
              height="50"
            >
              <span class="font-16 font-w-700">ยกเลิก</span>
            </v-btn>
          </v-flex>
          <v-flex xs6 class="pl-3">
            <v-btn
              @click="onSendExtendTime"
              block
              class="btn_gradient"
              rounded
              height="50"
            >
              <span class="font-16 font-w-700">ยืนยัน</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import {
  toDateFormat,
  toDateTimeFormat,
  formatNumber,
} from "@/plugins/global-funcs";

export default {
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      toDateFormat,
      toDateTimeFormat,
      formatNumber,
      theme: 2,
      rand: "cl-" + Math.random().toString().slice(2),
      isExpanded: false,
    };
  },
  methods: {
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    checkStatus(status) {
      if (status == "Submitted") {
        this.theme = 1;
        return {
          color: "#F9BB43",
          text: "รอพิจารณา",
        };
      } else if (status == "Reject") {
        this.theme = 4;
        return {
          color: "#F15A29",
          text: "ปฏิเสธขยายเวลา",
        };
      } else if (status == "Approved") {
        this.theme = 3;
        return {
          color: "#5CB844",
          text: "อนุมัติขยายเวลา",
        };
      } else {
        // Draft
        this.theme = 2;
        return {
          color: "#F15A29",
          text: "แบบร่าง",
        };
      }
    },
    onEdit(val) {
      this.$router.push(`/rsp/extend-time/${this.item.id}/form/${val.id}`);
    },
    onView(val) {
      this.$router.push(`/rsp/extend-time/detail/${val.id}`);
    },
    onDelete() {
      this.$emit("onDelete", this.item.id);
    },
    onPreview() {
      this.$router.push("/rsp/extend-time/detail/" + this.item.id);
    },
    extendRequest() {
      this.dialog = true;
    },
    onSendExtendTime() {
      console.log("onSendExtendTime");
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
.item_extend {
  .btn_gradient {
    background: linear-gradient(90deg, #f15a29 0%, #fbb040 100%) !important;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25) !important;
    color: #fff !important;
  }
}
.btn_gradient {
  background: linear-gradient(90deg, #f15a29 0%, #fbb040 100%) !important;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25) !important;
  color: #fff !important;
}
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>
